// How many of these mutators are still used?
export const STRIP_RETURN_CHARS = 'STRIP_RETURN_CHARS';
export const TO_UPPER_CASE = 'TO_UPPER_CASE';
export const TO_LOWER_CASE = 'TO_LOWER_CASE';
export const GLOBAL_ALL_VALUES = 'GLOBAL_ALL_VALUES';
export const STRIP_Q_STRING = 'STRIP_Q_STRING';
export const CAST_TO_NUMBER = 'CAST_TO_NUMBER';
export const ONLY_NUMBERS = 'ONLY_NUMBERS';
export const PIX_ARRAY_FIND_MIN = 'PIX_ARRAY_FIND_MIN';
export const PIX_ARRAY_FIND_MAX = 'PIX_ARRAY_FIND_MAX';
export const TRILOGY_FORMAT_CLICKED_FACET_NAME =
	'TRILOGY_FORMAT_CLICKED_FACET_NAME';

const mutateItem = (mutators, replacement) => {
	let mutatedValue = replacement;
	if (typeof mutatedValue === 'string') {
		mutators.forEach((mutator) => {
			switch (mutator) {
				case TO_LOWER_CASE:
					if (!mutatedValue.includes('.htm')) {
						mutatedValue = mutatedValue.toLowerCase();
					}
					break;
				case TO_UPPER_CASE:
					if (!mutatedValue.includes('.htm')) {
						mutatedValue = mutatedValue.toUpperCase();
					}
					break;
				case STRIP_RETURN_CHARS:
					mutatedValue = mutatedValue.replace(/[\r\n ]+/gm, ' ');
					break;
				case STRIP_Q_STRING:
					mutatedValue = mutatedValue
						.split('?')
						.shift()
						.split('com/')
						.pop();
					break;
				case ONLY_NUMBERS:
					mutatedValue = mutatedValue.replace(/\D/g, '');
					break;
				case CAST_TO_NUMBER:
					mutatedValue = +mutatedValue;
					break;
				case PIX_ARRAY_FIND_MIN:
					mutatedValue = mutatedValue
						.replace(/(-)/g, ',')
						.replace(/( )/g, '')
						.split(',');
					mutatedValue = mutatedValue.reduce((a, b) => {
						return Math.min(a, b);
					});
					break;
				case PIX_ARRAY_FIND_MAX:
					mutatedValue = mutatedValue
						.replace(/(-)/g, ',')
						.replace(/( )/g, '')
						.split(',');
					mutatedValue = mutatedValue.reduce((a, b) => {
						return Math.max(a, b);
					});
					break;
				case TRILOGY_FORMAT_CLICKED_FACET_NAME:
					mutatedValue = mutatedValue?.replace('normal', '');
					mutatedValue =
						mutatedValue?.charAt(0)?.toLowerCase() +
						mutatedValue.slice(1);
					break;
				default:
					break;
			}
		});
	}

	return mutatedValue;
};

export default mutateItem;
